import { axiosDefault } from 'src/utils/axios-helper';

const signOut = async (dist?: string) => {
  try {
    await axiosDefault.post('/user/api/sign-out');
  } finally {
    if (dist) window.location.href = dist;
    else window.location.reload();
  }
};

export default signOut;
